import { defineMessages } from 'react-intl';

export default defineMessages({
  offline: {
    defaultMessage: 'Continual access. Can be revoked from Settings',
    id: 'MKi5DY',
    description: 'IDP Scope Setting',
  },
  'carriers.read': {
    defaultMessage: 'View carrier information (read only)',
    id: 't/+cch',
    description: 'IDP Scope Setting',
  },
  packages: {
    defaultMessage: 'View and create package types',
    id: 'iUPxS/',
    description: 'IDP Scope Setting',
  },
  warehouses: {
    defaultMessage: 'View and create warehouse locations',
    id: '/BMYb2',
    description: 'IDP Scope Setting',
  },
  rates: {
    defaultMessage: 'Obtain shipping rates',
    id: '/Q9z54',
    description: 'IDP Scope Setting',
  },
  'quotes.write': {
    defaultMessage: 'Create delivery options shipping quotes',
    id: '3/XcFW',
    description: 'IDP Scope Setting',
  },
  quotes: {
    defaultMessage: 'View and create delivery options shipping quotes',
    id: 'N7Tu7c',
    description: 'IDP Scope Setting',
  },
  'delivery-options.quotes': {
    defaultMessage: 'View and create delivery options shipping quotes',
    id: 'N7Tu7c',
    description: 'IDP Scope Setting',
  },
  'delivery-options.quotes.write': {
    defaultMessage: 'Create delivery options shipping quotes',
    id: '3/XcFW',
    description: 'IDP Scope Setting',
  },
  fetchErrorNotificationTitle: {
    defaultMessage: 'Error Getting Consent Data',
    id: 'k7zZtC',
    description: 'IDP Fetch Data Notification Title',
  },
  fetchErrorNotificationContent: {
    defaultMessage: 'Could not retrieve consent data at this time. Please try again.',
    id: '1QsRtt',
    description: 'IDP Fetch Data Notification Content',
  },
  clientWantsAccess: {
    defaultMessage: '{clientName} wants access to your ShipStation account. This will allow {clientName} to:',
    id: '4e4cS/',
    description: 'IDP Client Message which Integration partner wants access',
  },
  accordanceStatement: {
    defaultMessage:
      '{clientName} and ShipStation will use this information in accordance with their respective terms of service and privacy policies.',
    id: 'JIkb8T',
    description: 'IDP Client Message which Integration partner wants access',
  },
  acceptConsent: {
    defaultMessage: 'Connect with {clientName}',
    id: 'ZwdP53',
    description: 'IDP Button to accept consent',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'OYhtz7',
    description: 'IDP Button to Cancel consent',
  },
  acceptedConsentText: {
    defaultMessage: 'You have successfully connected {clientName} with your ShipStation account.',
    id: 'WVkdRn',
    description: 'IDP Accepted Consent Message',
  },
  rejectedConsentText: {
    defaultMessage: 'You have rejected connecting {clientName} with your ShipStation account.',
    id: 'FpkZgZ',
    description: 'IDP Rejected Consent Message',
  },
  redirectConsentText: {
    defaultMessage: 'In a moment you will be redirected to {clientName}',
    id: 'swb18X',
    description: 'IDP Redirect Consent Message',
  },
});
